<template>
    <div :class="[
        componentBorder,
        componentRounded,
        componentPadding,
        componentBackground,
        'w-full max-w-full overflow-hidden flex justify-between gap-x-3',
    ]">
        <div class="flex flex-grow items-center gap-x-3">
            <ModelImage :src="imageSrc" :modelClass="modelClass" imageClasses="object-cover w-full h-full" :class="[
                small ? 'size-10' : imageSize,
                imageBorder,
                imageRounded,
                'aspect-square flex-shrink-0',
            ]" :typeId="typeId" :fileUrl="fileUrl" />
            <div :class="[
                small ? 'py-1.5' : ['flex-col', contentPadding],
                'flex flex-grow gap-y-1 h-full min-w-0 justify-between',
            ]">
                <TextTooltip :text="modelName">
                    <Link v-if="routeUrl" :href="routeUrl" target="_blank" v-text="modelName"
                        class="text-lg line-clamp-1 font-header underline-hover focus-style rounded-sm transition duration-button-hover pl-1 -ml-1" />

                    <p v-else v-text="modelName" class="text-lg line-clamp-1 font-header" />
                </TextTooltip>


                <div v-if="$slots.content" class="">
                    <slot name="content" />
                </div>
                <div v-else :class="[{ 'items-center': !small }, 'flex  gap-1 flex-wrap',]">
                    <ModelClassTag :modelClass="modelClass" />

                    <Tag v-for="tag in tags" :text="tag" :pill="true" class="bg-primary text-primary-text" />

                    <Tag v-for="tag in pendingTags" :text="tag" :pill="true" class="bg-gray-300 text-primary-text" />
                    <RoleTag v-if="pendingTags.length > 0" :small="true"
                        :text="$lang.get('A role request has been sent to the user')"
                        class="bg-gray-50 border-gray-100 rounded-full text-black" />
                </div>
            </div>
        </div>
        <div class="flex">
            <button v-if="showEditButton" @click="$emit('edit')"
                class="shrink-0 bg-white h-fit rounded-full p-px border border-border text-text mt-1.5 mr-1.5 hover:bg-gray-50 transition duration-button-hover focus-style"
                ref="editButton">
                <PhPencilSimple class="size-6 p-0.5" />
            </button>
            <button v-if="showRemoveButton" @click="$emit('remove')"
                class="shrink-0 bg-primary h-fit rounded-full p-px text-primary-text mt-1.5 mr-1.5 hover:bg-primary-hover transition duration-button-hover focus-style"
                ref="deleteButton">
                <PhX class="size-6" />
            </button>
        </div>
    </div>
</template>

<script>
import ModelClassTag from '@/Components/ModelComponents/ModelClassTag.vue'
import ModelImage from '@/Components/ModelComponents/ModelImage.vue'
import Tooltip from '@/Components/Elements/Tooltip.vue'
import Tag from '@/Components/Elements/Tags/Tag.vue'
import RoleTag from '@/Components/Elements/Tags/RoleTag.vue'
import { Link } from '@inertiajs/vue3'
import { PhX, PhPencilSimple } from '@phosphor-icons/vue'
import TextTooltip from '@/Components/Elements/TextTooltip.vue'
export default {
    components: {
        ModelClassTag,
        ModelImage,
        Tag,
        Link,
        PhX,
        PhPencilSimple,
        Tooltip,
        RoleTag,
        TextTooltip
    },

    emits: ['remove', 'edit'],

    expose: ['focusDeleteButton'],

    props: {
        imageSrc: {
            type: String,
        },
        imageSize: {
            type: String,
            default: 'size-20',
        },
        imageBorder: {
            type: String,
            default: 'border-r border-r-border',
        },
        imageRounded: {
            type: [String, Object],
            default: 'rounded-none',
        },
        componentBorder: {
            type: String,
            default: 'border border-border',
        },
        componentBackground: {
            type: String,
            default: 'bg-white',
        },
        componentRounded: {
            type: String,
            default: 'rounded-md ',
        },
        componentPadding: {
            type: String,
            default: '',
        },
        contentPadding: {
            type: String,
            default: 'py-2',
        },
        modelClass: {
            type: String,
            required: true,
        },
        modelName: {
            type: String,
            required: true,
        },
        routeUrl: {
            type: String,
        },
        showEditButton: {
            type: Boolean,
            default: false,
        },
        showRemoveButton: {
            type: Boolean,
            default: false,
        },
        tags: {
            type: Array,
            default: [],
        },
        pendingTags: {
            type: Array,
            default: []
        },
        typeId: {
            type: [String, null],
            default: null,
        },
        fileUrl: {
            type: String,
            default: null,
        },
        small: {
            type: Boolean,
            default: false,
        },
    },

    methods: {
        focusDeleteButton() {
            if (this.showRemoveButton) {
                this.$refs.deleteButton.focus()
            }
        },
    },
}
</script>
